<div [formGroup]="form">
  <!-- Compañía -->
  <mat-form-field *ngIf="company" appearance="fill" class="w-full">
    <mat-label>Compañía</mat-label>
    <mat-select formControlName="companyId" placeholder="Seleccione Compañía" (selectionChange)="onCompanyChange()">
      <mat-option [value]="null">Ninguno</mat-option>
      <mat-option *ngFor="let company of companyList" [value]="company.id">
        {{ company.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="companyWithMongoId" appearance="fill" class="w-full">
    <mat-label>Compañía</mat-label>
    <mat-select formControlName="companyId" placeholder="Seleccione Compañía" (selectionChange)="onCompanyChange()">
      <mat-option [value]="null">Ninguno</mat-option>
      <mat-option *ngFor="let company of companyList" [value]="company._id">
        {{ company.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Organización Ventas -->
  <mat-form-field *ngIf="salesOrganizationList?.length" appearance="fill" class="w-full">
    <mat-label>Organización Ventas</mat-label>
    <mat-select formControlName="salesOrganizationId">
      <mat-option [value]="null">Ninguno</mat-option>
      <mat-option *ngFor="let org of salesOrganizationList" [value]="org._id">
        {{ org.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Grupo de oficina de venta -->
  <mat-form-field *ngIf="officeGroup" appearance="fill" class="w-full">
    <mat-label>Grupo de oficina de venta</mat-label>
    <mat-select formControlName="salesOfficeGroupId" placeholder="Seleccione Grupo de oficina de venta"
      (selectionChange)="fetchAllSalesOffice()">
      <mat-option [value]="null">-- Ninguno --</mat-option>
      <mat-option *ngFor="let group of officeGroupList" [value]="group.id">
        {{ group.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Grupo de oficina de venta -->
  <mat-form-field *ngIf="officeGroupByMongoId" appearance="fill" class="w-full">
    <mat-label>Grupo de oficina de venta</mat-label>
    <mat-select formControlName="salesOfficeGroupId" placeholder="Seleccione Grupo de oficina de venta"
      (selectionChange)="fetchAllSalesOfficeBySalesOfficeMongoId()">
      <mat-option [value]="null">Ninguno</mat-option>
      <mat-option *ngFor="let group of officeGroupList" [value]="group._id">
        {{ group.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Oficina de venta -->
  <mat-form-field *ngIf="salesOffice" appearance="fill" class="w-full">
    <mat-label>Oficina de venta</mat-label>
    <mat-select formControlName="salesOfficeId" multiple>
      <mat-select-trigger>
        {{ getDisplayValue(salesOfficeList, form.get('salesOfficeId')?.value, "name") }}
      </mat-select-trigger>
      <mat-option *ngFor="let office of salesOfficeList" [value]="office.id">
        {{ office.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="salesOfficeWithMongoId" appearance="fill" class="w-full">
    <mat-label>Oficina de venta</mat-label>
    <mat-select formControlName="salesOfficeId" multiple>
      <mat-select-trigger>
        {{ getDisplayValue(salesOfficeList, form.get('salesOfficeId')?.value, "name") }}
      </mat-select-trigger>
      <mat-option *ngFor="let office of salesOfficeList" [value]="office._id">
        {{ office.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Cadena de Distribución -->
  <mat-form-field *ngIf="distributionChain" appearance="fill" class="w-full">
    <mat-label>Cadena de Distribución</mat-label>
    <mat-select formControlName="distributionChainId" multiple>
      <mat-select-trigger>
        {{ getDisplayValue(distributionChainList, form.get('distributionChainId')?.value, "name") }}
      </mat-select-trigger>
      <mat-option *ngFor="let chain of distributionChainList" [value]="chain.id">
        {{ chain.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="distributionChainWithMongoId" appearance="fill" class="w-full">
    <mat-label>Cadena de Distribución</mat-label>
    <mat-select formControlName="distributionChainId" multiple>
      <mat-select-trigger>
        {{ getDisplayValue(distributionChainList, form.get('distributionChainId')?.value, "name") }}
      </mat-select-trigger>
      <mat-option *ngFor="let chain of distributionChainList" [value]="chain._id">
        {{ chain.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

    <!-- Canal de Distribución -->
  <mat-form-field *ngIf="channelList?.length" appearance="fill" class="w-full">
    <mat-label>Canal de Distribución</mat-label>
    <mat-select formControlName="channelId" multiple>
      <mat-select-trigger>
        {{ getDisplayValue(channelList, form.get('channelId')?.value, "name") }}
      </mat-select-trigger>
      <mat-option *ngFor="let channel of channelList" [value]="channel.id">
        {{ channel.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Grupo de activos -->
  <mat-form-field *ngIf="groupsActiveControl" appearance="fill" class="w-full">
    <mat-label>Grupo/SubGrupo de control de activo</mat-label>
    <mat-select formControlName="groupActiveId" multiple>
      <mat-select-trigger>
        {{ getDisplayValue(groupList, form.get('groupActiveId')?.value, "name") }}
      </mat-select-trigger>
      <mat-option *ngFor="let group of groupList" [value]="group.code">
        {{ group.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Almacén -->
  <mat-form-field *ngIf="warehouse" appearance="fill" class="w-full">
    <mat-label>Almacén</mat-label>
    <mat-select formControlName="warehouseId" [compareWith]="compareById"
      (selectionChange)="onWarehouseSelectionChange($event.value)" multiple>
      <mat-select-trigger>
        {{ getDisplayValue(warehouseList, form.get('warehouseId')?.value, "name") }}
      </mat-select-trigger>
      <mat-option *ngFor="let warehouse of warehouseList" [value]="warehouse.id">
        <div *ngIf="getCode(warehouse) as code">
          <b class="f-9">{{ code }}</b>
        </div>
        {{ warehouse.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="warehouseWithMongoId" appearance="fill" class="w-full">
    <mat-label>Almacén</mat-label>
    <mat-select formControlName="warehouseId" [compareWith]="compareById"
      (selectionChange)="onWarehouseSelectionChange($event.value)" multiple>
      <mat-select-trigger>
        {{ getDisplayValue(warehouseList, form.get('warehouseId')?.value, "name") }}
      </mat-select-trigger>
      <mat-option *ngFor="let warehouse of warehouseList" [value]="warehouse._id">
        <div *ngIf="getCode(warehouse) as code">
          <b class="f-9">{{ code }}</b>
        </div>{{ warehouse.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Plantas -->
    <mat-form-field *ngIf="plant" appearance="fill" class="w-full">
    <mat-label>Plantas</mat-label>
    <mat-select formControlName="plantId" [compareWith]="compareById" multiple>
      <mat-select-trigger>
        {{ getDisplayValue(plantList, form.get('plantId')?.value, "name") }}
      </mat-select-trigger>
      <mat-option *ngFor="let plant of plantList" [value]="plant.id">
        {{ plant.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

    <!-- Division -->
    <mat-form-field *ngIf="division" appearance="fill" class="w-full">
    <mat-label>Division</mat-label>
    <mat-select formControlName="divisionId" [compareWith]="compareById" multiple>
      <mat-select-trigger>
        {{ getDisplayValue(divisionList, form.get('divisionId')?.value, "name") }}
      </mat-select-trigger>
      <mat-option *ngFor="let division of divisionList" [value]="division.id">
        {{ division.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field *ngIf="vehicleType" appearance="fill" class="w-full">
    <mat-label>Tipo de vehiculo</mat-label>
    <mat-select formControlName="vehicleTypeId" multiple>
      <mat-select-trigger>
        {{ getDisplayValue(reasonVehicleTypeList, form.get('vehicleTypeId')?.value, "name") }}
      </mat-select-trigger>
      <mat-option *ngFor="let type of filteredReasonVehicleTypeList" [value]="type.code">
        {{ type.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>